import { createSlice } from '@reduxjs/toolkit'

export const BidRequestSlice = createSlice(
  {
    name: 'bid_request',
    initialState: {
      value: {},
    },reducers: {
      updateBidRequestInfo: (state, action) => {
        if(action.payload.type){
            return { ...state,
                value:{
                  ...state.value,[action.payload.type]: action.payload.value
                }              
            }
        }
        else{
          state.value = action.payload
        }
      }
    }
})
export const { updateBidRequestInfo } = BidRequestSlice.actions

export default BidRequestSlice.reducer